import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { formatApiErrorDetail } from "../../api";
import { Field } from "./shared";

export function DecisionModal({ action, onClose, onConfirm }) {
  const isApprove = action === "approve";
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    if (!isApprove && text.trim().length < 3) {
      toast.error("Informe o motivo da rejeição (mínimo 3 caracteres).");
      return;
    }
    setSaving(true);
    try {
      await onConfirm(action, text.trim());
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      data-testid="expense-decision-modal"
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="bg-white w-full max-w-lg rounded-sm shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-slate-200">
          <h3 className="font-serif-display text-xl">
            {isApprove ? "Aprovar restituição" : "Rejeitar restituição"}
          </h3>
        </div>
        <div className="p-5">
          <Field label={isApprove ? "Comentário (opcional)" : "Motivo da rejeição *"}>
            <textarea
              rows={4}
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="mt-1 w-full border border-slate-300 px-3 py-2 rounded-sm resize-y"
              data-testid="expense-decision-comment"
            />
          </Field>
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
          <button
            onClick={onClose}
            data-testid="expense-decision-cancel"
            className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.25em] hover:bg-slate-50"
          >
            Cancelar
          </button>
          <button
            data-testid="expense-decision-confirm"
            onClick={confirm}
            disabled={saving}
            className={`inline-flex items-center gap-2 px-4 py-2 text-white text-[11px] uppercase tracking-[0.25em] disabled:opacity-60 ${
              isApprove ? "bg-emerald-700 hover:bg-emerald-800" : "bg-rose-700 hover:bg-rose-800"
            }`}
          >
            {saving && <Loader2 size={14} className="animate-spin" />}
            {isApprove ? "Confirmar aprovação" : "Confirmar rejeição"}
          </button>
        </div>
      </div>
    </div>
  );
}
